export const OTHER_DOC_TYPE_OPTION = 'other';
